export interface EchoNxFilterPipeProps {
    keyToShow: string, //value: string
    keyToSearch: string, //lang: string
    valueToSearch: string //"cz"
  }
